import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const FineArtPage = lazy(() => import('../pages/fine-art/page'));
const IllustrationPage = lazy(() => import('../pages/illustration/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/fine-art',
    element: <FineArtPage />,
  },
  {
    path: '/illustration',
    element: <IllustrationPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;